import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useQueryParams, StringParam } from 'use-query-params';

import { loadListingById } from '@redux/modules/listing';
import { loadFormDefinition } from '@redux/modules/formGeneration';
import { getSelectedListingData } from '@redux/selectors/ListingSelector';
import { selectFormDefinition, selectListingCode } from '@redux/selectors/FormSelector';

import CreateListingsForm from '@components/form/forms/CreateListingsForm';

const CreateListingsPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const currentFormDefinition = useSelector(selectFormDefinition);
  const currListing = useSelector(getSelectedListingData);
  const listingCode = useSelector(selectListingCode);

  const formCreate = useMemo(() => location?.pathname.includes('create'), [location]);
  const formEdit = useMemo(() => location?.pathname.includes('edit'), [location]);

  const [urlParams, setUrlParams] = useQueryParams({ UniqueID: StringParam, listingType: StringParam });

  const whereClause = {
    where: {
      clause: [],
    },
  };

  const alertUser = e => {
    e.preventDefault(); // cancel the event
    e.returnValue = ''; // chrome requires return value to be set
  };

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);

    if (urlParams?.listingType && (!currentFormDefinition?.length || (urlParams?.listingType !== listingCode))) {
      if (formCreate) {
        dispatch(loadFormDefinition('create', 'listings', urlParams?.listingType, null, 'listing'));
      }
      if (formEdit) {
        if (urlParams?.UniqueID) {
          whereClause.where.clause.push({ name: 'UniqueID', value: urlParams?.UniqueID });
          dispatch(loadFormDefinition('edit', 'listings', urlParams?.listingType, urlParams?.UniqueID, 'listing'));
          dispatch(loadListingById(whereClause));
        }
      }
    } else {
      const currUrl = location?.pathname?.split('/').pop();
      setUrlParams({ listingType: currUrl });
    }

    return () => window.removeEventListener('beforeunload', alertUser);
  }, []);

  /*
    This has to be done using location. Currently, when the user loads a form, it redirects the user to the
      create/edit page. When this happens, it clears out the path and search values in the location object.
      We can't memo the location and use that as a comparison, because technically the locations will be
      the same on the reload, so we can't reset the search value in the location object.
  */
  useEffect(() => {
    if (location?.search === '') {
      const currUrl = location?.pathname?.split('/').pop();
      setUrlParams({ listingType: currUrl });
      if (currListing) {
        setUrlParams({ UniqueID: currListing?.UniqueID }, 'pushIn');
      }
    }
  }, [location]);

  useEffect(() => {
    if (currListing) {
      if (!urlParams?.listingType) {
        setUrlParams({ UniqueID: currListing?.UniqueID }, 'pushIn');
      }
    }
  }, [currListing]);

  return (
    <>
      <div className="subheader">
        <h1 className="subheader-title">
          <i className="subheader-icon fal fa-ballot mr-2" />
          {formEdit ? 'Edit' : 'Create'}
          <span className="fw-300 ml-2 mr-2">Listing</span>
        </h1>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <CreateListingsForm />
        </div>
      </div>
    </>
  );
};

export default CreateListingsPage;
